<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th
                    class="align-middle"
                    rowspan="3"
                >
                    {{ i18n._719_CYCLES | translate }}
                </th>
                <th colspan="4">
                    {{ i18n._720_PERFORMANCE_AT_START_OF_CYCLE | translate }}
                </th>
                <th
                    class="align-middle"
                    rowspan="3"
                >
                    {{ i18n._721_GOAL | translate }}
                </th>
                <th colspan="4">
                    {{ i18n._722_PERFORMANCE_AT_END_OF_CYCLE | translate }}
                </th>
            </tr>
            <tr>
                <th colspan="2">{{ i18n._723_OVERALL | translate }}</th>
                <th colspan="2">{{ i18n._724_QUEUE_LEVEL | translate }}</th>
                <th colspan="2">{{ i18n._723_OVERALL | translate }}</th>
                <th colspan="2">{{ i18n._724_QUEUE_LEVEL | translate }}</th>
            </tr>
            <tr>
                <th>{{ i18n._725_ACTUAL | translate }}</th>
                <th>{{ i18n._726_TARGET | translate }}</th>
                <th>{{ i18n._725_ACTUAL | translate }}</th>
                <th>{{ i18n._726_TARGET | translate }}</th>
                <th>{{ i18n._725_ACTUAL | translate }}</th>
                <th>{{ i18n._726_TARGET | translate }}</th>
                <th>{{ i18n._725_ACTUAL | translate }}</th>
                <th>{{ i18n._726_TARGET | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <!--TODO revise tl-->
                <td>
                    {{ i.startDate | date: 'MMM d' }} -
                    {{ i.endDate | date: 'MMM d' }}
                </td>
                <td>
                    {{
                        i.start.overallActual == null
                            ? '-'
                            : (i.start.overallActual | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.start.overallTarget == null
                            ? '-'
                            : (i.start.overallTarget | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.start.queueActual == null
                            ? '-'
                            : (i.start.queueActual | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.start.queueTarget == null
                            ? '-'
                            : (i.start.queueTarget | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.goalValue == null
                            ? '-'
                            : (i.goalValue | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.end.overallActual == null
                            ? '-'
                            : (i.end.overallActual | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.end.overallTarget == null
                            ? '-'
                            : (i.end.overallTarget | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.end.queueActual == null
                            ? '-'
                            : (i.end.queueActual | number: '1.2-2')
                    }}
                </td>
                <td>
                    {{
                        i.end.queueTarget == null
                            ? '-'
                            : (i.end.queueTarget | number: '1.2-2')
                    }}
                </td>
            </tr>
        </tbody>
    </table>
</div>
